/** @jsxImportSource @emotion/react */
import { RouteFullScreenModal } from "../../../../components/RouteFullScreenModal";
import { Divider } from "../../../../components/Divider";
import { MutateCampaignForm } from "../components";

export const NewCampaignPage = () => {
  return (
    <RouteFullScreenModal title="Create new campaign">
      <Divider />
      <MutateCampaignForm />
    </RouteFullScreenModal>
  );
};
